exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container-fluid {\n  height: calc(100% - 70px); }\n  .container-fluid > .row {\n    height: 100%; }\n    .container-fluid > .row > .col-xs-12 {\n      height: 100%; }\n      .container-fluid > .row > .col-xs-12 > .panel {\n        height: 100%; }\n        .container-fluid > .row > .col-xs-12 > .panel > .panel-body {\n          height: 100%; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader!../node_modules/postcss-loader/lib??ref--3-2!../node_modules/sass-loader/lib/loader.js!./containers/example.container.scss
// module id = 512
// module chunks = 0